import { UseSelectStateChange } from "downshift";
import { useCallback } from "react";
import { SelectSharedProps } from "./Select.props";

export function useSelectHook<T>(props: SelectSharedProps<T>) {
  const { onSelectedItemChange, size, dropdownHeight, isWideRightAlign } =
    props;

  // Workaround for downshift bug where onSelectedItemChange is called infinitely when selecting an item in "touch" mode.
  // see https://github.com/downshift-js/downshift/issues/1511
  const memoizedOnSelectedItemChange = useCallback(
    (selectedItem: UseSelectStateChange<T>) => {
      setTimeout(() => onSelectedItemChange(selectedItem), 0);
    },
    [onSelectedItemChange]
  );

  const sizeProps = size === "sm" ? { height: "32px" } : {};

  const getDropdownHeight = (): string => {
    return dropdownHeight ?? "200px";
  };

  const getSelectStyle = () => {
    if (isWideRightAlign) {
      return { minWidth: "368px", right: 0 };
    }
    return {};
  };

  return {
    memoizedOnSelectedItemChange,
    sizeProps,
    getDropdownHeight,
    getSelectStyle,
  };
}
